import testimonialsConfig from './testimonials.json';
import { FALLBACK_LOCALE } from './locale';

function pickLocale(field, locale) {
  if (typeof field === 'string') return field;
  return field[locale] ?? field[FALLBACK_LOCALE] ?? '';
}

function mapReview(item, locale, quoteKey = 'quote') {
  return {
    img: item.avatar,
    name: item.name,
    quote: pickLocale(item[quoteKey], locale),
    role: pickLocale(item.role, locale),
  };
}

/** 评价区块标题文案 */
export function getTestimonialsSection(locale) {
  const { section } = testimonialsConfig;

  return {
    eyebrow: pickLocale(section.eyebrow, locale),
    title: pickLocale(section.title, locale),
    subtitle: pickLocale(section.subtitle, locale),
  };
}

/** 轮播评价列表 */
export function getSliderTestimonials(locale) {
  return testimonialsConfig.slider.map((item) => mapReview(item, locale));
}

/** 跑马灯评价列表 */
export function getMarqueeTestimonials(locale) {
  return testimonialsConfig.marquee.map((item) => ({
    ...mapReview(item, locale),
    body: pickLocale(item.quote, locale),
  }));
}
